"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RichWise_Website_API.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfMenuEditViewModel = instanceOfMenuEditViewModel;
exports.MenuEditViewModelFromJSON = MenuEditViewModelFromJSON;
exports.MenuEditViewModelFromJSONTyped = MenuEditViewModelFromJSONTyped;
exports.MenuEditViewModelToJSON = MenuEditViewModelToJSON;
exports.MenuEditViewModelToJSONTyped = MenuEditViewModelToJSONTyped;
/**
 * Check if a given object implements the MenuEditViewModel interface.
 */
function instanceOfMenuEditViewModel(value) {
    return true;
}
function MenuEditViewModelFromJSON(json) {
    return MenuEditViewModelFromJSONTyped(json, false);
}
function MenuEditViewModelFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'menuNo': json['menuNo'] == null ? undefined : json['menuNo'],
        'menuSys': json['menuSys'] == null ? undefined : json['menuSys'],
        'menuId': json['menuId'] == null ? undefined : json['menuId'],
        'menuParent': json['menuParent'] == null ? undefined : json['menuParent'],
        'parentMenuName': json['parentMenuName'] == null ? undefined : json['parentMenuName'],
        'menuName': json['menuName'] == null ? undefined : json['menuName'],
        'menuAname': json['menuAname'] == null ? undefined : json['menuAname'],
        'menuTitle': json['menuTitle'] == null ? undefined : json['menuTitle'],
        'menuPath': json['menuPath'] == null ? undefined : json['menuPath'],
        'menuOrder': json['menuOrder'] == null ? undefined : json['menuOrder'],
        'menuLinkType': json['menuLinkType'] == null ? undefined : json['menuLinkType'],
        'menuActive': json['menuActive'] == null ? undefined : json['menuActive'],
        'menuDisplay': json['menuDisplay'] == null ? undefined : json['menuDisplay'],
        'menuIcon': json['menuIcon'] == null ? undefined : json['menuIcon'],
    };
}
function MenuEditViewModelToJSON(json) {
    return MenuEditViewModelToJSONTyped(json, false);
}
function MenuEditViewModelToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'menuNo': value['menuNo'],
        'menuSys': value['menuSys'],
        'menuId': value['menuId'],
        'menuParent': value['menuParent'],
        'parentMenuName': value['parentMenuName'],
        'menuName': value['menuName'],
        'menuAname': value['menuAname'],
        'menuTitle': value['menuTitle'],
        'menuPath': value['menuPath'],
        'menuOrder': value['menuOrder'],
        'menuLinkType': value['menuLinkType'],
        'menuActive': value['menuActive'],
        'menuDisplay': value['menuDisplay'],
        'menuIcon': value['menuIcon'],
    };
}
